import { RoleScopeFormType } from 'components/roles/UpdateRoleScopeForm';

export const updateRoleScopeInitialValues: Partial<RoleScopeFormType> = {};
